<section id="home" class="relative scroll-mt-28 overflow-hidden">
    <div class="hero-aurora absolute inset-0" aria-hidden="true">
        <span class="hero-aurora-blob hero-aurora-blob--one"></span>
        <span class="hero-aurora-blob hero-aurora-blob--two"></span>
        <span class="hero-aurora-blob hero-aurora-blob--three"></span>
        <div class="hero-aurora-grid"></div>
    </div>

    <div class="relative mx-auto grid w-full max-w-7xl gap-10 px-4 py-16 sm:px-6 lg:grid-cols-[1.2fr_0.8fr] lg:px-8 lg:py-24">
        <div class="flex flex-col justify-center">
            <div class="inline-flex w-fit items-center gap-2 rounded-full border border-surface bg-surface-100 px-4 py-2 text-sm text-surface-700 shadow-lg shadow-black/10 dark:bg-white/5 dark:text-white/80">
                <span class="h-2.5 w-2.5 rounded-full bg-primary shadow-lg shadow-primary/20"></span>
                {{ text().heroBadge }}
            </div>
            <h1 class="mt-6 max-w-3xl text-5xl font-semibold tracking-tight text-surface-900 sm:text-6xl lg:text-7xl dark:text-white">
                {{ text().heroTitle }}
            </h1>
            <p class="mt-6 max-w-2xl text-lg leading-8 text-muted-color sm:text-xl">
                {{ text().heroSubtitle }}
            </p>

            <div class="mt-10 flex flex-wrap gap-4">
                <a (click)="scrollTo.emit('contact')" pButton pRipple class="cursor-pointer rounded-full bg-primary px-6 py-3 font-semibold text-primary-contrast shadow-xl shadow-primary/25">
                    {{ text().heroPrimary }}
                </a>
                <a (click)="scrollTo.emit('work')" pButton pRipple [text]="true" class="cursor-pointer rounded-full border border-surface px-6 py-3 font-semibold text-surface-900 dark:text-white">
                    {{ text().heroSecondary }}
                </a>
            </div>

            <div class="mt-12 grid gap-4 sm:grid-cols-3">
                @for (stat of text().heroStats; track stat.value; let i = $index) {
                    <div [appRevealOnScroll]="i * 120" class="rounded-3xl border border-surface bg-surface-50 p-4 backdrop-blur dark:bg-white/5">
                        <div class="text-3xl font-semibold text-primary">{{ stat.value }}</div>
                        <div class="mt-2 text-sm text-muted-color">{{ stat.description }}</div>
                    </div>
                }
            </div>
        </div>

        <div class="relative flex items-center justify-center">
            <div class="absolute inset-6 rounded-[2rem] border border-surface bg-surface-50 shadow-2xl shadow-primary/20 backdrop-blur-xl dark:bg-white/5"></div>
            <div class="relative w-full max-w-xl rounded-[2rem] border border-surface bg-surface-0 p-6 shadow-[0_40px_120px_rgba(0,0,0,0.15)] dark:bg-surface-900/90 dark:shadow-[0_40px_120px_rgba(0,0,0,0.45)]">
                <div class="flex items-center justify-between border-b border-surface pb-4">
                    <div>
                        <div class="text-sm uppercase tracking-[0.3em] text-muted-color">{{ text().heroPreview.liveStatusLabel }}</div>
                        <div class="text-2xl font-semibold text-surface-900 dark:text-white">{{ text().heroPreview.filePipelineLabel }}</div>
                    </div>
                    <span class="rounded-full bg-primary px-3 py-1 text-sm font-semibold text-primary-contrast">{{ text().heroPreview.processingBadge }}</span>
                </div>

                <div class="mt-6 space-y-4">
                    <div class="rounded-2xl border border-surface bg-surface-50 p-4 dark:bg-white/5">
                        <div class="flex items-center justify-between text-sm text-muted-color">
                            <span>{{ text().heroPreview.intakeLabel }}</span>
                            <span>{{ text().heroPreview.doneLabel }}</span>
                        </div>
                        <div class="mt-3 h-2 rounded-full bg-surface-200 dark:bg-white/10">
                            <div class="h-2 w-[100%] rounded-full bg-primary"></div>
                        </div>
                    </div>
                    <div class="rounded-2xl border border-surface bg-surface-50 p-4 dark:bg-white/5">
                        <div class="flex items-center justify-between text-sm text-muted-color">
                            <span>{{ text().heroPreview.processingStageLabel }}</span>
                            <span>{{ text().heroPreview.fastLabel }}</span>
                        </div>
                        <div class="mt-3 h-2 rounded-full bg-surface-200 dark:bg-white/10">
                            <div class="h-2 w-[82%] rounded-full bg-primary"></div>
                        </div>
                    </div>
                    <div class="rounded-2xl border border-surface bg-surface-50 p-4 dark:bg-white/5">
                        <div class="flex items-center justify-between text-sm text-muted-color">
                            <span>{{ text().heroPreview.resultsLabel }}</span>
                            <span>{{ text().heroPreview.readyLabel }}</span>
                        </div>
                        <div class="mt-3 h-2 rounded-full bg-surface-200 dark:bg-white/10">
                            <div class="h-2 w-[94%] rounded-full bg-primary"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
